import {
  Alarm,
  DataVersion,
  LocationAlarmUpdatesDTO,
  ScanAlarmUpdateType,
  UnifiedAlarm,
} from '@hakimo-ui/hakimo/types';
import { BasicPanel } from '@hakimo-ui/hakimo/ui-elements';
import { eventTracker, useCanChangeAlarmStatus } from '@hakimo-ui/hakimo/util';
import { Button } from '@hakimo-ui/shared/ui-base';
import { useMemo, useState } from 'react';
import AlarmStatusBadge from '../../shared/components/badge/AlarmStatusBadge';
import { AlarmStatusModal } from './AlarmStatusModal';

interface Props {
  alarm?: Alarm;
  event?: UnifiedAlarm;
  updates?: LocationAlarmUpdatesDTO;
  onResolve?: () => void;
  dataVersion?: DataVersion;
}

export function AlarmStatusPanel(props: Props) {
  const { alarm, event, updates, onResolve, dataVersion } = props;
  const canChangeStatus = useCanChangeAlarmStatus();
  const [open, setOpen] = useState(false);

  const onClose = () => {
    setOpen(false);
  };

  const statusToShow = useMemo(() => {
    if (event) {
      if (updates) {
        const llmEvent = updates.items.find(
          (u) =>
            u.update_type === ScanAlarmUpdateType.LLM_EVENT &&
            (!u.event_id || u.event_id === event.id)
        );
        if (!llmEvent) {
          return 'Analyzing';
        }
        return llmEvent.recommendation?.toLowerCase() === 'resolve'
          ? 'Resolved by Hakimo'
          : 'Pending';
      }
      if (event.tap && event.tap <= 70) {
        return 'Resolved by Hakimo';
      }
      return 'Pending';
    }
    return alarm?.status;
  }, [event, updates, alarm?.status]);

  return (
    <BasicPanel title="Status">
      <div className="flex items-center justify-between p-6">
        {statusToShow && <AlarmStatusBadge status={statusToShow} />}
        {canChangeStatus && alarm && (
          <Button
            variant="primary"
            onClick={() => setOpen(true)}
            onSideEffect={eventTracker('open_alarm_status_update_modal')}
          >
            Update
          </Button>
        )}
      </div>

      {open && alarm && (
        <AlarmStatusModal
          open={true}
          alarm={alarm}
          onCloseCb={onClose}
          onResolveCb={onResolve}
          dataVersion={dataVersion}
        />
      )}
    </BasicPanel>
  );
}

export default AlarmStatusPanel;
